import { apiGet } from '../client';
import { AIRLINE_STATS_API_KEY } from '../../config/env';
import { ApiError } from '../types/common';
import type { AirlineStatsRequest, AirlineStatsResponse } from '../types/airlineStats';

const MISSING_KEY_MESSAGE =
  'Havayolu istatistikleri API anahtarı yapılandırılmamış (REACT_APP_AIRLINE_STATS_API_KEY).';

/**
 * `GET /api/airlinestats?startDate=&endDate=&provider=` — the one session-less GET route
 * (see `types/airlineStats.ts`). The `/backend-api` prefix comes from the axios `baseURL`;
 * the route here is bare `api/airlinestats`. Auth is the `X-Api-Key` header.
 *
 * Guard: with no configured key the backend answers 401 — fail fast with a clear message
 * instead. A backend 400 (bad `yyyy-MM-dd`) is re-surfaced as a readable Turkish notice.
 */
export async function getAirlineStats(req: AirlineStatsRequest): Promise<AirlineStatsResponse> {
  if (!AIRLINE_STATS_API_KEY) throw new Error(MISSING_KEY_MESSAGE);

  try {
    return await apiGet<AirlineStatsResponse>('api/airlinestats', {
      params: {
        startDate: req.startDate,
        endDate: req.endDate,
        provider: req.provider || undefined,
      },
      headers: { 'X-Api-Key': AIRLINE_STATS_API_KEY },
    });
  } catch (err) {
    if (err instanceof ApiError && /\b400\b/.test(err.message)) {
      throw new ApiError('Tarih formatı geçersiz — başlangıç ve bitiş tarihleri yyyy-AA-gg olmalı.');
    }
    throw err;
  }
}
